import type { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import { createContext, useContext } from 'react';

// Stytch session management interface
export interface StytchSession {
  revoke(): Promise<any>; // Returns ResponseCommon but we don't need the response
}

// Re-export the actual Stytch client type for components that need full SDK access
export type { StytchB2BUIClient };

// Stytch B2B SDK instance interface (minimal for legacy compatibility)
export interface StytchB2BInstance {
  session?: StytchSession;
}

export interface StytchB2BGlobal {
  // Minimal shape we use; the real SDK provides many more methods
  new (publicToken: string): StytchB2BInstance;
}

declare global {
  interface Window {
    StytchB2B?: StytchB2BGlobal;
  }
}

export interface StytchContextValue {
  // The actual Stytch B2B UI client with full SDK methods (oauth, discovery, etc.)
  stytch: StytchB2BUIClient | null;
  ready: boolean;
  error?: string | null;
}

export const StytchContext = createContext<StytchContextValue>({ stytch: null, ready: false });

export const useStytch = () => useContext(StytchContext);
